import { useState, useCallback } from 'react';
import quarkusApi from '../../../../api/quarkusApi';

export function useSaveAnamnesis() {
  const [isSaving, setSaving] = useState(false);

  const save = useCallback((anamnese) => {
    setSaving(true);
    const authHeader = { headers: { Authorization: sessionStorage.getItem('token') } };
    const request = anamnese.id
      ? quarkusApi.put('/anamnesis', anamnese, authHeader)
      : quarkusApi.post('/anamnesis', anamnese, authHeader);
    return request.finally(() => setSaving(false));
  }, []);

  return { save, isSaving };
}
